import { gql } from "@apollo/client";

const INBOX_DETAIL_CHANGED = gql`
  subscription inboxdetailchanged {
    inboxdetailchanged {
      id
      inboxId
      customerName
      customerPicture
      source
      chatorder
      messageId
      messagetext
      messagetimestamp
      read
      marknottoaddinchatcircle
      labels
      agentId
      salesDone
      customerId
      pageId
      pageName
      accesstoken
    }
  }
`;

export default INBOX_DETAIL_CHANGED;
